export default __webpack_public_path__ + "static/node@2x-a579e47d5729a7689aa8ce976a8a1761.png";